export const fetcher = async (url) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Ошибка при загрузке: ${res.statusText}`);
  }
  const data = await res.json();
  return data;
};
